// Port of api/fuel/app/classes/filter/search/games/filters/query/play/status.php
export default {
	name: 'play.status',
	priority: 60,
	require: function(config, filter) { return filter.play && filter.play.status },
	run: function(config, filter, data, query) {
		if (filter.play.status === 1) query.where('p.play_incomplete', '=', 0)
		else if (filter.play.status === 2) query.where('p.play_incomplete', '=', 1)
	}
}
